import { merge } from 'lodash';
import { environment as baseEnvironment } from '../environment.base';

export const environment = merge(baseEnvironment, {});



// WEBPACK FOOTER //
// /vercel/workpath0/src/environments/environment.ts